import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "top" }
const _hoisted_2 = {
  key: 0,
  class: "fas fa-exclamation-triangle"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-check"
}
const _hoisted_4 = {
  key: 2,
  class: "fas fa-exclamation"
}
const _hoisted_5 = { class: "center" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = {
  key: 0,
  class: "confirm"
}
const _hoisted_9 = {
  key: 1,
  class: "confirm"
}
const _hoisted_10 = {
  key: 2,
  class: "cancel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.alert)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "overlay",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, [
            _createElementVNode("div", {
              class: "alert",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stopPropagation && _ctx.stopPropagation(...args)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.alert.icon === "exclamation-triangle")
                  ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                  : (_ctx.alert.icon === "check")
                    ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                    : (_openBlock(), _createElementBlock("i", _hoisted_4)),
                _createElementVNode("h1", null, _toDisplayString(_ctx.alert.title), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.alert.subtitle), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "b",
                  innerHTML: _ctx.alert.text
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.alert.confirm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_ctx.alert.type === "danger")
                        ? (_openBlock(), _createBlock(_component_NButton, {
                            key: 0,
                            onClick: _ctx.onConfirm,
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.alert.confirm), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_ctx.alert.type === "positive")
                          ? (_openBlock(), _createBlock(_component_NButton, {
                              key: 1,
                              onClick: _ctx.onConfirm,
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.alert.confirm), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_NButton, {
                              key: 2,
                              onClick: _ctx.onConfirm
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.alert.confirm), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.alert.confirm2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_ctx.alert.type === "danger")
                        ? (_openBlock(), _createBlock(_component_NButton, {
                            key: 0,
                            onClick: _ctx.onConfirm2,
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.alert.confirm2), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_NButton, {
                            key: 1,
                            onClick: _ctx.onConfirm2
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.alert.confirm2), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.alert.cancel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_NButton, { onClick: _ctx.onCancel }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.alert.cancel), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}